module.exports = __webpack_public_path__ + "img/signal-alt.5cbcda2b.svg";